module.exports = __webpack_public_path__ + "img/boy_001_thumb.c9be9932.jpg";